import APIService from '@/api'

export default class APIStreet extends APIService{

    constructor(){
        super('streets')
    }

    getAll() {
        var response = this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }
}


// WEBPACK FOOTER //
// ./src/api/street.js